// Module
var code = "<h4>FR</h4>";
// Exports
module.exports = code;